import { BILLING_API } from '@Constants/backendConstants';
import { usePagedListApi } from '@Hooks/useListApi';
import { InvoiceSnapshotsRepository } from '@Repositories/Billing';
import type { ListRequest } from '@synqo/frontend-component-library';
import { useQuery } from '@tanstack/react-query';

/**
 * How many invoice snapshots `selection` matches. Asks nothing while `selection` is undefined, and keeps the
 * count it already has for a selection while it asks again.
 */
// @ai-generated 2026-09-30T03:36:37+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5 (1M context)
export function useInvoiceSnapshotCount(selection: ListRequest | undefined) {
    const listApi = usePagedListApi(InvoiceSnapshotsRepository, BILLING_API);

    const { data, isFetching } = useQuery({
        queryKey: ['invoice_snapshots', 'count', selection],
        queryFn: async () => (await listApi.loadPage({ ...selection!, page_no: 0, page_size: 1 })).total_item_count,
        enabled: selection !== undefined,
    });

    return { count: selection === undefined ? undefined : data, isLoading: isFetching && data === undefined };
}
